import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { LinkButton, CtaCard } from '@domain-group/fe-co-allhomes-design-system';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var Illustration = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/media-cta-illustration_44566b87.svg";
import * as styles from './explore-cta-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ctaText = 'Explore suburb profiles';
var subtitle = 'Looking for suburb profiles and past sales information?';
var ExploreCtaCard = () => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX(CtaCard, {
    subtitle: subtitle,
    appearance: "vertical",
    startElement: ___EmotionJSX("img", {
      src: Illustration,
      css: styles.img,
      alt: ""
    }),
    css: styles.ctaCard,
    endElement: ___EmotionJSX(LinkButton, {
      appearance: "outline",
      href: getAbsoluteUrl('/research'),
      onClick: () => sendEvent('explore-research-cta', {
        subtitle,
        ctaText
      })
    }, ctaText)
  });
};
export default ExploreCtaCard;